import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from 'react-select';

const AssetsField = ({ assetsLiabilitiesSelectOptions }) => {
  return (
    <Field name="assets" parse={values => values.map(({ value }) => value)}>
      {({ input }) => (
        <Fragment>
          <label>Assets</label>
          <Select {...input} multi options={assetsLiabilitiesSelectOptions} className="form-select" />
        </Fragment>
      )}
    </Field>
  );
};

AssetsField.propTypes = {
  assetsLiabilitiesSelectOptions: PropTypes.array.isRequired,
};

export default AssetsField;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/fields/AssetsField.jsx